define('constants/selectControlAvatarType',[], function() {
    return Object.freeze({
        user: 'user',
        userGroup: 'userGroup'
    });
});
